import { h } from "preact";

export default function ({ href, children, ...rest }: any) {
  return (
    <a href={href} {...rest} data-link>
      {children}
    </a>
  );
}
